export default __webpack_public_path__ + "static/media/mc.90e3a99f.jpg";